import React from 'react';

interface TwoDBoxesIconProps {
  style?: React.CSSProperties;
}

const TwoDBoxesIcon: React.FC<TwoDBoxesIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>2D Box Annotation</title>
      <path d="M12.99 0v15l12.99 7.5v-15L12.99 0z" fill="#6A11EA" />
      <path d="M8.661 2.499v15l12.99 7.5v-15l-12.99-7.5z" fill="#943CFF" />
      <path d="M4.329 5.001v15l12.993 7.5v-15l-12.993-7.5z" fill="#DD45D3" />
      <path d="M0 7.5v15L12.99 30V15L0 7.5z" fill="#FD9D52" />
    </svg>
  );
};

export default TwoDBoxesIcon;
